export { getAuthAdapter } from './amplify-auth-adapter'
